import { combineReducers, AnyAction } from "redux";

import { default as reducers } from "./reducers";
import { RESET_STORE } from "./actions";

export { default as rootSaga } from "./sagas";

const appReducer = combineReducers({ ...reducers });

export type RootState = ReturnType<typeof appReducer>;
export const rootReducer = (
  state: RootState | undefined,
  action: AnyAction = { type: "" },
): RootState => {
  if (action.type === RESET_STORE) {
    state = undefined;
  }
  return appReducer(state, action);
};
